// extracted by mini-css-extract-plugin
export default {"deviceContainer":"manufactured-device-card_deviceContainer__IMHXy"};